var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      attrs: { title: _vm.$t("lbl_detail_x", { x: _vm.$t("lbl_work_order") }) }
    },
    [
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v(" " + _vm._s(_vm.$t("lbl_general")) + " ")]),
          _c(
            "a-form-model",
            {
              ref: "formModel",
              attrs: {
                "label-align": "left",
                "wrapper-col": { span: 12 },
                "label-col": { span: 7 }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: [16, 16] } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_wo_number"),
                            prop: "documentNumber"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              "data-testid": "wo-document-number",
                              disabled: ""
                            },
                            model: {
                              value: _vm.store.detail.documentNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.store.detail,
                                  "documentNumber",
                                  $$v
                                )
                              },
                              expression: "store.detail.documentNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_branch"),
                            prop: "branchWarehouse"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              value: _vm.store.detail.branchWarehouse,
                              "data-testid": "wo-branch",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_wo_date"),
                            prop: "workOrderDate"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              value: _vm.store.detail.workOrderDate,
                              format: _vm.DEFAULT_DATE_FORMAT,
                              "data-testid": "wo-date",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_schedule_order"),
                            prop: "scheduleOrder"
                          }
                        },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              value: _vm.store.detail.scheduleOrder,
                              format: _vm.DEFAULT_DATE_FORMAT,
                              "disabled-date": _vm.useDisabledBackDate,
                              "data-testid": "wo-schedule-order",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_mechanic_name"),
                            prop: "mechanicName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              value: _vm.store.detail.mechanicName,
                              "data-testid": "wo-mechanic",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_description"),
                            prop: "description",
                            "label-align": "right"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "extra",
                              fn: function() {
                                return [
                                  _c("character-length", {
                                    attrs: {
                                      value: _vm.store.detail.description
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              value: _vm.store.detail.description,
                              name: "wo-description",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_customer_name"),
                            prop: "customerName",
                            "label-align": "right"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              value: _vm.store.detail.customerName,
                              "data-testid": "wo-customer",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_customer_address"),
                            prop: "customerAddress",
                            "label-align": "right"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              value: _vm.store.detail.customerAddress,
                              "data-testid": "wo-customer-address",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_customer_pic_name"),
                            prop: "picName",
                            "label-align": "right"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              value: _vm.store.detail.picName,
                              "data-testid": "wo-pic-name",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.$t("lbl_document_reference"),
                            prop: "docReference",
                            "label-align": "right"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              value: _vm.store.detail.sparePartRequestNumber,
                              "data-testid": "wo-pic-doc-ref",
                              disabled: ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v(" " + _vm._s(_vm.$t("lbl_unit")) + " ")]),
          _c("a-table", {
            attrs: {
              "row-key": "assetId",
              "data-source": _vm.store.detail.units,
              columns: _vm.unitColumns,
              pagination: false,
              size: "small",
              scroll: { y: 600, x: "calc(100% + 100px)" }
            },
            scopedSlots: _vm._u([
              {
                key: "nullable",
                fn: function(text) {
                  return [_vm._v(" " + _vm._s(text || "-") + " ")]
                }
              }
            ])
          }),
          _c("div", { staticClass: "mt-2 text-right" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("lbl_total_items", {
                    total: _vm.store.detail.units.length
                  })
                ) +
                " "
            )
          ])
        ],
        1
      ),
      _c(
        "fieldset",
        [
          _c("legend", [_vm._v(" " + _vm._s(_vm.$t("lbl_part")) + " ")]),
          _c("a-table", {
            attrs: {
              "row-key": "productId",
              "data-source": _vm.store.detail.spareParts,
              columns: _vm.sparepartColumns,
              pagination: false,
              size: "small",
              scroll: { y: 600, x: "calc(100% + 200px)" }
            },
            scopedSlots: _vm._u([
              {
                key: "number",
                fn: function(text) {
                  return [_vm._v(" " + _vm._s(_vm._f("qty")(text)) + " ")]
                }
              },
              {
                key: "nullable",
                fn: function(text) {
                  return [_vm._v(" " + _vm._s(text || "-") + " ")]
                }
              }
            ])
          }),
          _c("div", { staticClass: "mt-2 text-right" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("lbl_total_items", {
                    total: _vm.store.detail.spareParts.length
                  })
                ) +
                " "
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-5 text-right" },
        [
          _c(
            "a-space",
            [
              _c("a-button", { on: { click: _vm.handleBack } }, [
                _vm._v(_vm._s(_vm.$t("lbl_back")))
              ]),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loading.print },
                  on: { click: _vm.handlePrintCsf }
                },
                [_vm._v(" " + _vm._s(_vm.$t("lbl_print_csf")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }